import posthog from "posthog-js";
import type {
  DemoJoinFailureReason,
  DemoUnsupportedReason,
} from "@/lib/types/demo-session";

export type SessionEventType =
  | "session_created"
  | "session_started"
  | "session_ended"
  | "session_error"
  | "feedback_viewed"
  | "media_permission_changed";

type DemoEventType =
  | SessionEventType
  | "demo_unsupported_shown"
  | "demo_cta_download"
  | "demo_cta_extension"
  | "demo_cta_share"
  | "demo_freeze_started"
  | "demo_freeze_ended";

export type SessionEventData = {
  sessionId?: string;
  scenarioType?: string;
  duration?: number;
  errorMessage?: string;
  mediaType?: "audio" | "video";
  enabled?: boolean;
  reason?: DemoUnsupportedReason | DemoJoinFailureReason | "manual" | "auto";
  os?: "mac" | "windows";
  mode?: "browser";
  method?: "share" | "copy";
  heldMs?: number;
};

/** Marcus training events: dev console only, never sent to PostHog. */
export function trackSessionEvent(
  event: SessionEventType,
  data: SessionEventData,
): void {
  if (process.env.NODE_ENV === "development") {
    console.log(`[Analytics] ${event}:`, data);
  }
}

export function trackDemoEvent(
  event: DemoEventType,
  data: SessionEventData,
): void {
  // Skip before posthog.init() (no key in local builds).
  if (!posthog.__loaded) return;
  posthog.capture(event, data);
}
